import { Alert, PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Grid } from '@material-ui/core'
import { HexColorInput } from 'react-colorful'
import styled from 'styled-components'

import { StyledAlert } from '../../ImageEditor/styled'

export const GridRelativePosition = styled(Grid)`
  position: relative;
`

export const StyledGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 10px;
`

export const ImageEditorContainer = styled.div`
  margin: -8px -10px -15px -10px;
  ${StyledAlert} {
    padding-top: 0;
    padding-left: 10px;
    padding-right: 10px;
  }
`

export const InputContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  padding: 10px;
  border-radius: 4px;
  overflow: hidden;
  white-space: nowrap;
`

export const InputLabel = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.coolGray.cool700};
  overflow: hidden;
  white-space: nowrap;
`

export const StyledHexColorInput = styled(HexColorInput)`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 14px;
  width: 100%;
  border: 0 transparent;
  &:focus {
    outline: unset;
  },
`

export const ColorPickerContainer = styled.div`
  padding: 0 10px 10px 10px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  .react-colorful {
    height: 150px;
    width: auto;
  }
  .react-colorful__saturation {
    border-radius: 4px;
  }
  .react-colorful__hue {
    margin-top: 10px;
    height: 14px;
    border-radius: 7px;
  }
`

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  width: 100%;
`

export const AlertGutterTop = styled(Alert)`
  margin-top: 10px;
  // override margin-bottom in child element
  && > div {
    margin-bottom: 0;
  }
`
